export class SetConsent {
  static readonly type = '[CookieConsent] Set consent';
  constructor() {}
}

export class RevokeConsent {
  static readonly type = '[CookieConsent] Revoke consent';
  constructor() {}
}
